<div class="main-layout">
  <app-sidebar [isOpen]="sidebarOpen" (toggleSidebar)="toggleSidebar()"></app-sidebar>
  <div class="content-wrapper" [class.sidebar-collapsed]="!sidebarOpen">
    <app-header [sidebarOpen]="sidebarOpen"></app-header>
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

